// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntfoot th {\r\n    vertical-align: middle !important;\n}\ntfoot th > div {\r\n    width: 100% !important;\n}\ntfoot th > div > div {\r\n    width: 100% !important;\n}\ntfoot th .mb-3 {\r\n    margin-bottom: 0 !important;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
